<template>
  <div>
    <base-card :with_title="false">
      <template slot="content">
        <v-data-table
          :headers="headers"
          :items="employees"
          class="elevation-0"
          :loading="loading"
          :search="search"
          hide-default-footer
        >
          <template v-slot:item.role_names="{item}">
            {{ $t(`employees.roles.${item.role_names}`) }}
          </template>
          <template v-slot:item.actions="{item}">
            <v-btn icon small color="primary" @click="showEmployee(item)">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
          </template>
        </v-data-table>

      </template>
      <template></template>
    
    </base-card>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
import Api from '@/api/index';

export default {
  name: 'EmployeeList',
  //mixins: [ validations ],
  components: {
    //ComponentName: () => import(''),
  },
  data() {
    return {
      loading: false,
      employees: [],
      search: null,
      selectedRow: null,
      headers: [
        {text: this.$t('name'), value: 'name',},
        {text: this.$t('employees.role_form_label'), value: 'role_names',},
        {text: this.$t('contact'), value: 'json_attributes.phone',},
        {text: 'E-mail', value: 'email',},
        {text: this.$t('action'), value: 'actions', sortable: false},
      ],

      sortBy: '',
      sortDesc: null,
    }
  },
  methods: {
    getEmployees() {
      this.loading = true
      // Api.User.index().then(r=>r.data).then(d=> {
      //   this.employees = [...d]
      // }).catch(err=> {
      //   console.log({err});
      // }).finally(()=>{
      //   this.loading = false
      // })

      Api.Employee.index().then(r=>r.data).then(d=> {
        this.employees = [...d]
      }).catch(err=> {
        console.log({err});
      }).finally(()=>{
        this.loading = false
      })
    },
    showEmployee(item){
      this.$router.push({name: 'ShowEmployee', params: {id: item.emp_id}})
    },

    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  mounted () {
    this.getEmployees();
  },
  watch: {
    '$route'(nv,ov) {
      // console.log({ov, nv});
      if (['ShowEmployee', 'NewEmployee'].includes(ov.name)){
        this.getEmployees()
      }
    }
  },
}
</script>

<style lang="scss" scoped>

</style>